import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/AuthContext";
import { Loader2, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-brand-paper flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <img src="/picto-instant.png" alt="Agence Instant" className="h-9 w-9 object-contain" />
          <div className="h-9 w-px bg-brand-line" />
          <div className="leading-none">
            <div className="font-display text-xl text-brand-ink">Instant Studio</div>
            <div className="eyebrow mt-1">by Agence Instant</div>
          </div>
        </div>

        <div className="rounded-lg border border-brand-line bg-white p-8 shadow-card">
          <h1 className="font-display text-3xl text-brand-ink">Mot de passe oublié</h1>
          <p className="mt-2 text-sm text-brand-subtle">
            Entrez votre email et nous vous enverrons un lien de réinitialisation.
          </p>

          {sent ? (
            <div className="mt-8 rounded-md border border-brand-line bg-brand-paper px-4 py-3 text-sm text-brand-ink" data-testid="forgot-sent-message">
              Si cet email est associé à un compte, un lien de réinitialisation vient d'être envoyé. Pensez à vérifier vos spams.
            </div>
          ) : (
            <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="forgot-form">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email" type="email" autoComplete="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                />
              </div>
              {error && (
                <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                  {error}
                </div>
              )}
              <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
              </Button>
            </form>
          )}

          <div className="mt-6">
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-brand-subtle hover:text-brand-ink">
              <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
